import styled, { css } from 'styled-components';

interface IContainerProps {
  isErrored: boolean;
  isFocused: boolean;
}

export const Container = styled.div<IContainerProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.4rem;
  position: relative;

  label {
    display: flex;
    flex-direction: row;
    color: var(--black);
    font-size: 0.9rem;
  }

  textarea {
    resize: none;
    min-height: 10rem;
    padding: 0.4rem 0 0 1.4rem;
    border: 1px solid transparent;
    background-color: var(--gray_light_light);
    border-radius: 0.2rem;
    font-size: 0.9rem;
    font-weight: 500;
    word-break: break-all;

    &::placeholder {
      color: var(--gray_medium);
    }

    &:focus {
      border-color: var(--primary_color);
    }

    ${props =>
      props.isErrored &&
      css`
        border-color: var(--red) !important;
      `}
  }

  .input-error {
    top: 0.5rem;
  }

  & + & {
    margin-top: 1rem;
  }
`;
